import { useWSMutation } from "../../helpers";
import { setCoverageOnInsuranceCoverageMonitor } from "../../../services/api/insurance/monitor/setCoverageOnInsuranceCoverageMonitor";
import {
  InsuranceCoverageMonitor,
  SetCoverageOnInsuranceCoverageMonitorRequest
} from "../../../services/api/insurance/monitor/types";
import { QUERY_INSURANCE_COVERAGE_MONITOR } from "../queries/useQueryInsuranceCoverageMonitor";

type UseSetCoverageOnInsuranceCoverageMonitorProps =
  SetCoverageOnInsuranceCoverageMonitorRequest & {
    insuranceCoverageMonitorId: string;
  };

export const useMutationSetCoverageOnInsuranceCoverageMonitor = () => {
  return useWSMutation<
    InsuranceCoverageMonitor,
    unknown,
    UseSetCoverageOnInsuranceCoverageMonitorProps
  >(
    async ({
      insuranceCoverageMonitorId,
      ...request
    }: UseSetCoverageOnInsuranceCoverageMonitorProps) => {
      return await setCoverageOnInsuranceCoverageMonitor(
        insuranceCoverageMonitorId,
        request
      );
    },
    {
      dependencies: [QUERY_INSURANCE_COVERAGE_MONITOR]
    }
  );
};
